module.exports = __webpack_public_path__ + "static/media/Harveast_gif_tv.69c8db10.gif";